import { Field, InputType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import type { FilterQuery, QueryOptions } from '../repository'
import { ActionArgs } from './ActionArgs'

@InputType()
export abstract class QueryArgs<T> extends ActionArgs {
  @Field(() => GraphQLJSON, { nullable: true })
  filter?: FilterQuery<T>

  @Field(() => GraphQLJSON, { nullable: true })
  options?: QueryOptions<T>
}
